<div class="modal-header">
  <div class="modal-title">{{ modalTitle }}</div>
  <button (click)="onCancel()" class="btn-close btn-close-white" type="button" aria-label="Close"></button>
</div>

<div class="modal-body">
  <div class="confirmation-info">
    @if (icon) {
      <div class="confirmation-icon">
        <i class="material-icons">{{ icon }}</i>
      </div>
    }
    <div>
      <p [innerHTML]="confirmationMessage | safeHtml"></p>
    </div>
    <ng-content></ng-content>
  </div>
</div>

<div class="modal-footer">
  @if (showCancelButton === true) {
    <pas-button (click)="onCancel()" icon="close" color="dark" text="{{ cancelButtonLbl }}"></pas-button>
  }

  <!-- TODO: why a confirm! button does have a danger! color? fix this! -->
  <pas-button
    [disabled]="!acceptanceAllowed"
    [ngClass]="{ disabled: !acceptanceAllowed }"
    (click)="acceptanceAllowed ? onConfirm() : null"
    icon="chevron_right"
    color="danger"
    text="{{ acceptButtonLbl }}"></pas-button>
</div>
